export type GameStatus = "running" | "wip" | "down";

export interface GameConfig {
  id: string;
  name: string;
  description: string;
  icon: string;
  version: string;
  status: GameStatus;
  statusMessage?: string;
}

export const games: GameConfig[] = [
  {
    id: "snake",
    name: "Snake",
    description: "Classic snake game with a terminal twist",
    icon: "🐍",
    version: "v1.0.0",
    status: "running",
  },
  {
    id: "tictactoe",
    name: "TicTacToe",
    description: "The classic X's and O's game",
    icon: "⭕",
    version: "v1.0.0",
    status: "running",
  },
  {
    id: "tetris",
    name: "Tetris",
    description: "The legendary block-stacking game",
    icon: "🟪",
    version: "v1.0.0",
    status: "running",
  },
];
